import React from 'react';
import PropTypes from 'prop-types';
import AmexExpandableSection from './AmexExpandableSection';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexExpandableSections.scss';

const AmexExpandableSections = (
  {
    awsFolderName,
    baseRequestUrl,
    matchMedia,
    expandableConfig: {
      title = '',
      expandable_sections: expandableSections = [],
    },
    eventAnalytics,
  }
) => {
  const sanitizedTitle = sanitizeString(title);

  return (
    <section className="AmexExpandableSections">
      <div className="container">
        {title && (
          <h2
            className="AmexExpandableSections__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
        )}
        {expandableSections && expandableSections.map((section, index) => (
          <AmexExpandableSection
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            sectionConfig={section}
            matchMedia={matchMedia}
            eventAnalytics={eventAnalytics}
            id={`expandableSection${index}`}
          />
        ))}
      </div>
    </section>
  );
};

AmexExpandableSections.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  expandableConfig: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    expandable_sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  eventAnalytics: PropTypes.func.isRequired,
};

export default AmexExpandableSections;
